import { remoteCall } from "./RemoteService";

const LOAD_LOCAL = false;

let DB = null;
const getDB = async ()=> {
    if (!DB) DB = await import("../datamodule/DB");
    return DB.default;
}

export const getQueryConditions = (queryParams, keyDatas)=> {
    const conditions = [];
    if (queryParams.query) {
        for (let [key, value] of Object.entries(queryParams.query)) {
            key = key.replace(/\++/g, '');
            if (value == null || value == '') continue;
            if (value instanceof Array) {
                const opt = queryParams.options && queryParams.options[key];
                switch (opt) {
                    case 'multi-relate':
                        conditions.push({key:key, value:JSON.stringify(value), type:7})
                        break;
                    case 'min-range':
                        if (value && value[0] != null) conditions.push({key:key, value:value[0], type:5});
                        if (value && value[1] != null) conditions.push({key:key, value:value[1], type:6});
                        break;
                    case 'range':
                        if (value && value[0] != null) conditions.push({key:key, value:value[0], type:8});
                        if (value && value[1] != null) conditions.push({key:key, value:value[1], type:9});
                        break;
                    case 'relate-in':
                        conditions.push({key:key, value:value.join(','), type:12});
                        break;
                    case 'relate-notin':
                        conditions.push({key:key, value:value.join(','), type:13});
                        break;
                    case 'notin': 
                        conditions.push({key:key, value:value.join(','), type:3});
                        break;
                    default:
                        const vs = [];
                        for (let v of value) {
                            if (v != null) vs.push((v + '').replace(/^\s*|\s*$/g, ''))
                        }
                        conditions.push({key:key, value:vs.join(','), type:2});
                        break;
                }
            } else if (value instanceof Object) {
                conditions.push({key:key, value:JSON.stringify(value.path), type:7});
            } else {
                const opt = queryParams.options && queryParams.options[key];
                if (opt == 'not-null') {
                    conditions.push({key:key, value:'1', type:15})
                } else if (opt == 'null') {
                    conditions.push({key:key, value:'1', type:14})
                } else if(opt == 'find-child'){
                    conditions.push({key:key, value:value , type:21})

                }else{
                    if (value != null) value = (value + '').replace(/^\s*|\s*$/g, '');
                    conditions.push({key:key, value:value, type:queryParams.options && queryParams.options[key] == 'like' ? 0 : 1});
                }
            }
        }
    }
    if (keyDatas) {
        if (!(keyDatas instanceof Array)) keyDatas = [keyDatas];
        for (const keyData of keyDatas) {
            if (keyData.path.length) {
                const path = keyData.path.slice();
                if (keyData.value instanceof Array) {
                    path.push(keyData.value);
                } else {
                    path.push([keyData.value.toString()]);
                }
                conditions.push({key:keyData.destField, value:JSON.stringify(path), type:7});
            } else {
                const value = keyData.value;
                if (value instanceof Array) {
                    const opt = queryParams.options && queryParams.options[keyData.destField];
                    switch (opt) {
                        case 'multi-relate':
                            conditions.push({key:keyData.destField, value:JSON.stringify(value), type:7})
                            break;
                        case 'range':
                            if (value && value[0] != null) conditions.push({key:keyData.destField, value:value[0], type:8});
                            if (value && value[1] != null) conditions.push({key:keyData.destField, value:value[1], type:9});
                            break;
                        case 'relate-in':
                            conditions.push({key:keyData.destField, value:value.join(','), type:12});
                            break;
                        case 'relate-notin':
                            conditions.push({key:keyData.destField, value:value.join(','), type:13});
                            break;
                        case 'notin':
                            conditions.push({key:keyData.destField, value:value.join(','), type:3});
                            break;
                        default:
                            conditions.push({key:keyData.destField, value:value.join(','), type:2});
                            break;
                    }
                } else {
                    conditions.push({key:keyData.destField, value:value, type:queryParams.options && queryParams.options[keyData.destField] == 'like' ? 0 : 1});
                }
            }
        }
    }
    return conditions;
}
const getQueryConditionsv0 = (queryParams, keyDatas)=> {
    const query = Object.assign({}, queryParams.query);
    if (keyDatas) {
        if (!(keyDatas instanceof Array)) keyDatas = [keyDatas];
        for (const keyData of keyDatas) {
            if (keyData.value != null) {
                if (keyData.value instanceof Array) {
                    query[keyData.destField] = keyData.value.join(',');
                } else {
                    query[keyData.destField] = keyData.value;
                }
            }
        }
    }
    return query;
}
const moduleToType = (module)=> {
    return module.replace(/([A-Z])/g, function($0, $1) {
        return '_' + $1.toLowerCase()
    })
}
const typeToModule = (type)=> {
    return type.replace(/\_([a-z])/g, function($0, $1) {
        return $1.toUpperCase();
    })
}
const getUrlData = (link, data, res) => {
    if (!link) return link;
    link = link.replace(/[\?\&\#]([\w]+)\=\{([^\=\&]+)\}/g, (_, $1, $2) => {
        let val = null;
        if (data instanceof Array) {
            const v = [];
            for (const d of data) {
                v.push(d[$2]);
            }
            val = v;
        } else {
            val = data[$2];
        }
        if (val != null) res[$1] = val;
        return '';
    })
    link = link.replace(/[\?\&\#]([\w]+)\=([^\=\&]*)/g, (_, $1, $2) => {
        const val = $2;
        if (val != null && val != '') res[$1] = val;
        else res[$1] = null;
        return '';
    })
    return link;
}
export const formatDataUrl = (url, data) => {
    const params = {};
    const body = {};
    url = url.replace(/(\?[^\#]+)|(\#[^\?]+)/g, (_, $1, $2) => {
        const queryLink = $1;
        const bodyLink = $2;
        let res = '';
        if (queryLink) res = getUrlData(queryLink, data, params);
        if (bodyLink) res = getUrlData(bodyLink, data, body)
        return res;
    })
    if (data instanceof Array) {
        const fields = [];
        url.replace(/\{(\w+)\}/g, ($0, $1)=> {
            return fields.push($1);
        })
        const obj = {};
        for (const d of data) {
            for (const f of fields) {
                let fs = obj[f];
                if (!fs) fs = obj[f] = [];
                fs.push(d[f] || '');
            }
        }
        // get data for url
        url = url.replace(/\{(\w+)\}/g, ($0, $1)=> {
            const v = obj[$1];
            return v ? v.join(',') : '';
        })
    } else {
        url = url.replace(/\{(\w+)\}/g, ($0, $1)=> {
            return data[$1] || '';
        })
    }
    return {url:url, params:params, body:body};
}
export  function addURLParams(url, params) {
    if (params == null) return url;
    const paramList = [];
    switch (typeof params) {
        case 'string': paramList.push(params);
        case 'number': paramList.push(params)
        case 'object': for (let f in params) {
            let s = params[f];
            paramList.push(f + '=' + s);
        }
    }
    let p = paramList.join('&');
    if (!p) return url;
    if (/\?/.test(url)) return url + '&' + p;
    return url + '?' + p;
}
// export function getUrlParams(url) {
//     var params = {};
//     url.replace(/[\?\&]([^\?\&\=\#]+)\=?([^\?\&\#]+)/g, function($0, $1, $2) {
//         params[$1] = $2;
//         return $0;
//     })
//     return params;
// }

const getDictDatas = async (type, status)=> {
    const url = addURLParams('/dev-api/model/referdata/listAll', status != null ? {typeCode:type, status:status} : {typeCode:type});
    const res = await remoteCall(url, {params:null, data:null, loadingState:0 }, true);
    if (res == -1) return null;
    if (res.data && res.data.length) {
        return res.data.sort((a, b)=> a.orders - b.orders);
    }
    return res.data;
}
const getDictDatasv0 = async (type, status)=> {
    const url = addURLParams('/dev-api/model/referdata/listAll', status != null ? {typeCode:type, status:status} : {typeCode:type});
    const res = await remoteCall(url, {params:null, data:null, loadingState:0 }, true);
    if (res == -1) return null;
    if (res.data && res.data.length) {
        return res.data.sort((a, b)=> a.orders - b.orders);
    }
    return res.data;
}
const queryDatasWithUrl = async (url, queryParams, pagination, extData)=> {
    let query = queryParams;
    let findIndex = queryParams.findIndex(it=>it.key=='interfaceType')
    if(findIndex!=-1){
       const interfaceType = JSON.parse(query[findIndex].value)
       for (const key in interfaceType) {
        if (Object.hasOwnProperty.call(interfaceType, key)) {
            const type = interfaceType[key];
            query.forEach(it => {
                if(it.key == key){
                    it.type = type
                }
            });
        }
       }
    }
    const res = await remoteCall(url, {params:null, data:{queryCondition:query, page:pagination}, loadingState:1 }, true);
    if (res == -1) return null;
    if (extData && res && res.summary) {
        extData.summary = res.summary;
    }
    if (res.pageNumber != null) pagination.pageNumber = res.pageNumber;
    pagination.total = res.total;
    return res.data;
}
const queryDatasWithUrlGet = async(url, queryParams, pagination, extData)=> {
    const res = await remoteCall(url, {params:Object.assign({}, queryParams, pagination), data:null, loadingState:1 }, true);
    if (res == -1) return null;
    if (extData && res && res.summary) {
        extData.summary = res.summary;
    }
    if (res.pageNumber != null) pagination.pageNumber = res.pageNumber;
    pagination.total = res.total;
    return res.data;
}
const queryDatas = async (module, queryParams, pagination, extData)=> {
    const url = '/dev-api/ebk/' + module + '/selectPageList';
    return queryDatasWithUrl(url, queryParams, pagination, extData);
}
const queryDatasWithUrlv0 = async(url, queryParams, pagination, extData)=> {
    const res = await remoteCall(url, {params:Object.assign({}, queryParams, pagination ? {pageSize:pagination.pageSize, pageNumber:pagination.pageNumber} : null), data:null, loadingState:1}, true)
    if (res == -1) return null;
    if (extData && res && res.summary) {
        extData.summary = res.summary;
    }
    if (pagination && res.pageNumber != null) pagination.pageNumber = res.pageNumber;
    if (pagination && res.total) pagination.total = res.total;
    return res.rows || res.data;
}
const queryDatasv0 = async(module, queryParams, pagination, extData)=> {
    if (pagination) {
        const url = '/dev-api/system/' + module + '/list';
        return queryDatasWithUrlv0(url, queryParams, pagination, extData);
    } else {
        const url = '/dev-api/system/' + module + '/listAll';
        return queryDatasWithUrlv0(url, queryParams, null, extData);
    }
}
const getDatasWithUrl = async (url, queryParams, pagination, config)=> {
    url = addURLParams(url, {r:Math.random()})
    const res = await remoteCall(url, {params:null, data:Object.assign({queryCondition:queryParams, page:pagination}, config), loadingState:-1 }, true)
    if (res == -1) return null;
    return res.data;
}
const getDatasWithUrlv0 = async (url, field, keys)=> {
    const res = await remoteCall(url + (keys ? keys.join(',') : ''), {params:null, data:null, loadingState:-1 }, true)
    if (res == -1) return null;
    return res.data;
}
const getDatas = async (module, queryParams, pagination, config)=> {
    // 标准--列表
    const url = '/dev-api/ebk/' + module + '/selectList';
    return getDatasWithUrl(url, queryParams, pagination, config);
}
const getDataWithUrlv0 = async (url, key)=> {
    const res = await remoteCall(url + key, {params:null, data:null, loadingState:1 }, true)
    if (res == -1) return null;
    return res.data;
}
const getDataWithUrlPostv0 = async (url, key)=> {
    const res = await remoteCall(url + key, {params:null, data:{}, loadingState:0 }, true)
    if (res == -1) return null;
    const data = res.data;
    return (data instanceof Array) ? (data[0] || null) : data;
}
const getDatav0 = async (module, key)=> {
    const url = '/dev-api/system/' + module + '/';
    return getDataWithUrlv0(url, key);
}
const insertDataWithUrl = async (url, data)=> {
    // 标准--新增
    const res = await remoteCall(url, {params:null, data:data, loadingState:3}, true)
    if (res == -1) return null;
    return res.data ? Object.assign(data, res.data) : null;
}
const insertData = async (module, data)=> {
    // 标准--新增
    const url = '/dev-api/ebk/' + module + '/insert';
    return insertDataWithUrl(url, data);
}
const insertDataWithUrlv0 = async (url, data)=> {
    const res = await remoteCall(url, {params:null, data:data, loadingState:-1}, true)
    if (res == -1) return null;
    return res.data ? Object.assign(data, {id:res.data}) : null;
}
const insertDatav0 = async (module, data)=> {
    const url = '/dev-api/system/' + module ;
    return insertDataWithUrlv0(url, data);
}
const insertDatasWithUrl = async (url, datas)=> {
    const res = await remoteCall(url, {params:null, data:datas, loadingState:3}, true)
    if (res == -1) return null;
    return res.data;
}
const insertDatas = async (module, datas)=> {
    const url = '/dev-api/ebk/' + module + '/batchInsert';
    return insertDatasWithUrl(url, datas);
}
const updateDataWithUrl = async (url, data, conf)=> {
    const res = await remoteCall(url, {params:null, data:data, type:'put', loadingState:conf?.showLoading != null ? 3 : -1}, true)
    if (res == -1) return null;
    return res.data ? Object.assign(data, {/*id:res.data*/}) : null;
}
const updateData = async (module, data, conf)=> {
    // 标准--修改
    const url = '/dev-api/ebk/' + module + '/update';
    return updateDataWithUrl(url, data, conf);
}
const updateDataWithUrlv0 = async (url, data)=> {
    const res = await remoteCall(url, {params:null, data:data, type:'put', loadingState:3}, true)
    if (res == -1) return null;
    return res.data ? Object.assign(data, {/*id:res.data*/}) : null;
}
const updateDatav0 = async (module, data)=> {
    const url = '/dev-api/system/' + module ;
    return updateDataWithUrlv0(url, data);
}
const updateDatas = async (module, datas)=> {
    const url = '/dev-api/ebk/' + module + '/batchUpdate';
    const res = await remoteCall(url, {params:null, data:datas, type:'put', loadingState:3}, true)
    if (res == -1) return null;
    return res.data ? Object.assign(res.data, {/*id:res.data*/}) : null;
}
const getServerTime = async ()=> {
    const url = '/dev-api/auth/getNow';
    const res = await remoteCall(url, {params:null, data:{}, loadingState:-1}, true);
    if (res == -1) return null;
    return res.data;
}
const removeDatasWithUrl = async (url, keys)=> {
    const res = await remoteCall(url + keys.join(','), {params:null, type:'delete', loadingState:0}, true)
    if (res == -1) return null;
    return res.data;
}
const removeDatas = async (module, keys)=> {
    // 标准--删除
    const url = '/dev-api/ebk/' + module + '/deleted/';
    return removeDatasWithUrl(url, keys);
}
const removeDataWithUrlv0 = async (url, key)=> {
    const res = await remoteCall(url + key, {params:null, type:'delete', loadingState:0}, true)
    if (res == -1) return null;
    return res.data;s
}
const removeDatav0 = async (module, key)=> {
    const url = '/dev-api/system/' + module + '/';
    return removeDataWithUrlv0(url, key);
}
const nextData = async (module, key, keyField,contractKey, condition)=> {
    const url = '/dev-api/ebk/' + module + '/selectOne';
    if (!condition) condition = [];
    console.log('key', key)
    console.log('key', keyField)
    condition = condition.concat([{key:keyField, value:key, type:6},{key:'contractId', value:contractKey, type:2}]);
    const res = await remoteCall(url, {params:null, data:{queryCondition:condition}});
    if (res == -1) return null;
    return res.data;
}

const getUserInfo = async ()=> {
    return remoteCall('/dev-api/system/user/getInfo', {loadingState:1}, true);
}
const getMenuRoute = async ()=> {
    return remoteCall('/dev-api/system/menu/getRouters', {loadingState:1}, true);
}
const getDicts=  async (type)=> {
    const url = addURLParams('/dev-api/system/dict/data/type/' + type);
    const res = await remoteCall(url, {params:null, data:null, loadingState:0 }, true);
    if (res == -1) return null;
    return res.data;
}

const system = localStorage.getItem('system') || 'application';

class RemoteCenter {
    static async loadDictDatasWithUrl(url) {
        if (LOAD_LOCAL) {
            const type = url.getUrlParam('dataType');
            const module = typeToModule(type);
            return RemoteCenter.loadDictDatas(module);
        } else {
            return getDatasWithUrl(url, system == 'application' ? {query:{status:2}} : null);
        }
    }
    static async loadDictDatasWithUrlv0(url) {
        if (LOAD_LOCAL) {
            const type = url.getUrlParam('dataType');
            const module = typeToModule(type);
            return RemoteCenter.loadDictDatas(module);
        } else {
            return getDatasWithUrlv0(url);
        }
    }
    static async loadDictDatas(module) {
        if (LOAD_LOCAL) {
            return (await getDB()).queryAll(module);
        } else {
            // console.log(module)
            const type = moduleToType(module);
            return getDictDatas(type, system == 'application' ? 0 : null);
        }
    }
    static async loadDictDatasv0(module) {
        if (LOAD_LOCAL) {
            return (await getDB()).queryAll(module);
        } else {
            // console.log(module)
            const type = moduleToType(module);
            return getDictDatasv0(type, system == 'application' ? 0 : null);
        }
    }
    static async queryDatas(module, queryParams, keyData, pagination, extData) {
        // query 的值需要根据通用接口的形式进行调整
        if (system == 'application' && queryParams?.query?.status == null) {
            if (!queryParams) queryParams = {};
            if (!queryParams.query) queryParams.query = {};
            queryParams.query.status = 2; 
        }
        const query = getQueryConditions(queryParams, keyData);
        if (LOAD_LOCAL) {
            return (await getDB()).queryDatas(module, query, pagination).data;
        } else {
            if (pagination && pagination.pageSize) return queryDatas(module, query, pagination, extData);
            return getDatas(module, query, pagination);
        }
    }
    static async queryDatasv0(module, queryParams, keyData, pagination, extData) {
        // if (system == 'application' && queryParams?.query?.status == null) {
        //     if (!queryParams) queryParams = {};
        //     if (!queryParams.query) queryParams.query = {};
        //     queryParams.query.status = 2; 
        // }
        const query = getQueryConditionsv0(queryParams, keyData);
        return queryDatasv0(module, query, pagination, extData);
    }
    static async queryDatasWithUrl(url, queryParams, keyData, pagination, extData) {
        if (system == 'application' && queryParams?.query?.status == null) {
            if (!queryParams) queryParams = {};
            if (!queryParams.query) queryParams.query = {};
            queryParams.query.status = 2; 
        }
        const query = getQueryConditions(queryParams, keyData);
        if (LOAD_LOCAL) {
            // return (await getDB()).queryDatas(module, query, pagination);
        } else {
            if (queryParams.method == 'GET') {
                if (pagination) return queryDatasWithUrlGet(url, queryParams.query, pagination, extData)
            } else {}
            if (pagination) return queryDatasWithUrl(url, query, pagination, extData);
            return getDatasWithUrl(url, query);
        }
    }
    static async queryDatasWithUrlv0(url, queryParams, keyData, pagination) {
        // if (system == 'application' && queryParams?.query?.status == null) {
        //     if (!queryParams) queryParams = {};
        //     if (!queryParams.query) queryParams.query = {};
        //     queryParams.query.status = 2; 
        // }
        const query = getQueryConditionsv0(queryParams, keyData);
        return queryDatasWithUrlv0(url, query, pagination);
    }
    static async fmpContractQueryDatas(module, queryParams, keyData, pagination) {

    }
    static async getAllDatas(module) {
        if (LOAD_LOCAL) {
            // return (await getDB()).getDatasByField(module, field, keys);
        } else {
            return getDatas(module, []);
        }
    }
    static async getDatasByField(module, field, keys) {
        if (LOAD_LOCAL) {
            return (await getDB()).getDatasByField(module, field, keys);
        } else {
            if (keys instanceof Array) {
                return getDatas(module, [{key:field, value:keys.join(','), type:2}]);
            } else {
                return getDatas(module, [{key:field, value:keys, type:1}]);
            }
        }
    }
    static async getDatasByFieldWithUrl(url, field, keys) {
        if (LOAD_LOCAL) {
        } else {
            if (keys instanceof Array) {
                return getDatasWithUrl(url, [{key:field, value:keys.join(','), type:2}]);
            } else {
                return getDatasWithUrl(url, [{key:field, value:keys, type:1}]);
            }
        }
    }
    static async getDatasByFieldv0(module, field, keys) {
        const ps = [];
        for (const key of keys) {
            ps.push(getDatav0(module, key));
        }
        return Promise.all(ps);
    }
    static async getDatasByFieldWithUrlv0(url, field, keys) {
        const ps = [];
        for (const key of keys) {
            ps.push(getDataWithUrlPostv0(url, key));
        }
        return Promise.all(ps);
    }
    static async getData(module, key, keyField) {
        if (LOAD_LOCAL) {
            return (await getDB()).getData(module, key, keyField);
        } else {
            const datas = await getDatas(module, [{key:keyField, value:key}]);
            return datas && datas.length ? datas[0] : null;
        }
    }
    static async getDatav0(module, key, keyField) {
        return await getDatav0(module, key);
    }
    static async getDataWithUrl(url, key, keyField) {
        if (LOAD_LOCAL) {
            // return DB.getData(module, key, keyField);
        } else {
            const datas = await getDatasWithUrl(url, [{key:keyField, value:key}]);
            return datas && datas.length ? datas[0] : null;
        }
    }
    static async getDataWithUrlv0(url, key, keyField) {
        return await getDataWithUrlv0(url, key);
    }
    static async insertData(module, data) {
        if (LOAD_LOCAL) {

        } else {
            return insertData(module, data);
        }
    }
    static async insertDatav0(module, data) {
        return insertDatav0(module, data);
    }
    static async insertDataWithUrl(url, data) {
        if (LOAD_LOCAL) {

        } else {
            return insertDataWithUrl(url, data);
        }
    }
    static async insertDataWithUrlv0(url, data) {
        return insertDataWithUrlv0(url, data);
    }
    static async updateData(module, data) {
        if (LOAD_LOCAL) {

        } else {
            return updateData(module, data);
        }
    }
    static async updateDatas(module, datas) {
        return updateDatas(module, datas);
    }
    static async insertDatas(module, datas) {
        return insertDatas(module, datas);
    }
    static async insertDatasWithUrl(url, datas) {
        return insertDatasWithUrl(url, datas);
    }
    static async updateDatav0(module, data) {
        return updateDatav0(module, data);
    }
    static async updateDataWithUrl(url, data) {
        if (LOAD_LOCAL) {

        } else {
            return updateDataWithUrl(url, data);
        }
    }
    static async updateDataWithUrlv0(url, data) {
        return updateDataWithUrlv0(url, data);
    }
    static async removeDatas(module, keys) {
        if (LOAD_LOCAL) {

        } else {
            return removeDatas(module, keys);
        }
    }
    static async removeDatasv0(module, keys) {
        if (!keys || !keys.length) return;
        for (const key of keys) {
            removeDatav0(module, key);
        }
    }
    static async getNextData(module, key, keyField,contractKey, filter) {
        console.log('getNextData',key,keyField,contractKey )
        if (LOAD_LOCAL) {

        } else {
            return nextData(module, key, keyField,contractKey, filter);
        }
    }
    static async getDicts(type) {
       return  getDicts(type)
    }
    static async getUserInfo() {
        return getUserInfo();
    }
    static async getMenuRoute() {
        return getMenuRoute()
    }
    static async remoteCall(url, data, config) {
        return remoteCall(url, {data:data, type:config.type, loadingState:config.loadingState != null ? config.loadingState : 2}, true)
    }

    static async simpleCall(url, data, type) {
        return remoteCall(url, {data:data, type:type, loadingState:0}, true)
    }

    static async getServerTime() {
        return getServerTime();
    }
}

export default RemoteCenter;